export default "<h1>Group list</h1>\n<xodos-group-table [clickHandler]=\"createClickHandler()\"></xodos-group-table>";